import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    enableRehash: false,
}

export const abExperimentSlice = createSlice({
    name: "abExperiment",
    initialState: initialState,
    reducers: {
        reset: () => initialState,
        setRehashFlag: (state, action) => {
            state.enableRehash = action.payload
        },
    },
})

export const abExperimentReducer = abExperimentSlice.reducer
export const { setRehashFlag } = abExperimentSlice.actions
